import { ReactNode } from 'react';
import styles from './HighlightedCard.module.scss';

const HighlightedCard = ({ children, className = '' }: { children: ReactNode; className?: string }) => (
  <div className={`${styles.card} ${className}`}>{children}</div>
);

export { HighlightedCard };
